import Text from './Text';
import Checkbox from './Checkbox';
import Select from './Select';
import Date from './Date';
import RadioGroup from './RadioGroup';
import RadioGroupWithWritein from './RadioGroupWithWritein';
import AutocompleteSelect from './AutocompleteSelect';
import SeaService from './SeaService';
import ImageSelect from './ImageSelect';
import AutoField from './AutoField';
import AutoAddition from './AutoAddition';
import Table from './Table';
import Signature from './Signature';

import cg719sFields from 'components/forms/cg719s/fields';
import codFields from 'components/forms/cod/fields';
import sslFields from 'components/forms/ssl/fields';

const formFields = {
    cg719s: cg719sFields,
    cod: codFields,
    ssl: sslFields,
};

export {
    AutoField,
    Text,
    Checkbox,
    Select,
    Date,
    RadioGroup,
    RadioGroupWithWritein,
    AutocompleteSelect,
    SeaService,
    ImageSelect,
    formFields,
    AutoAddition,
    Table,
    Signature,
};
